import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;

  svg {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.colors.neutral.neutral70};
  }

  input {
    width: 100%;
    height: 36px;
    padding: 0 10px 0 32px;
    border: 1px solid ${({ theme }) => theme.colors.neutral.neutral30};
    border-radius: 8px;
    outline: none;
  }
`;
